export default __webpack_public_path__ + "static/media/contact-us-illustration.74df3df8.svg";